import angular from 'angular';

angular.module('folkeuni').component('navigationSearch', {
  templateUrl: '/shop-dist/templates/navigation-search.html',
  bindings: {
    searchUrl:'@'
  },
  controller: function ($sce) {
      var $ctrl = this;

      $ctrl.trustSrc = function(src) {
        return $sce.trustAsResourceUrl(src);
      }
  }
});
